{
  "components": {
    "notificationsList": {
      "noData": "There are no notifications in this section.",
      "today": "Today",
      "yesterday": "Yesterday",
      "earlier": "Earlier",
      "search": "Search",
      "goToTaskNotification": {
        "title": "Please wait",
        "description": "You're being redirected to the selected task",
        "notAllowed": {
          "title": "You are not allowed to access this task",
          "description": "You are not allowed to access the task which is not assigned to you."
        }
      },
      "actions": { "goToTask": "View details" }
    }
  }
}
